/**
 * Styling constants for disabled/locked UI elements
 */
export const DEAL_LOCK_STYLES = {
    DISABLED_OPACITY: '0.5',
    DISABLED_CURSOR: 'not-allowed',
    DISABLED_POINTER_EVENTS: 'none',
    DISABLED_BACKGROUND: '#E3E3E3',
    DISABLED_COLOR: '#666666',
    DISABLED_BORDER: '#E3E3E3'
} as const;

/**
 * Common disabled styles applied to locked UI elements
 */
const COMMON_DISABLED_STYLES = {
    pointerEvents: `${DEAL_LOCK_STYLES.DISABLED_POINTER_EVENTS} !important`,
    opacity: `${DEAL_LOCK_STYLES.DISABLED_OPACITY} !important`,
    cursor: `${DEAL_LOCK_STYLES.DISABLED_CURSOR} !important`,
    backgroundColor: `${DEAL_LOCK_STYLES.DISABLED_BACKGROUND} !important`,
    color: `${DEAL_LOCK_STYLES.DISABLED_COLOR} !important`,
    borderColor: `${DEAL_LOCK_STYLES.DISABLED_BORDER} !important`
} as const;

/**
 * CSS selectors for customer UI elements that need to be disabled when deal is locked
 */
export const DEAL_LOCK_SELECTORS = {
    VIN_BUTTONS:
        '#vin-link-button, #customer-card-change-history-button, [data-testid="vin-link-button"], [data-testid="customer-card-change-history-button"]',
    TEXT_CUSTOMER_BUTTON: '#customer-inbox-open-reply-button, [data-testid="customer-inbox-open-reply-button"]'
} as const;

/**
 * Creates styles object for disabling UI elements when deal is locked
 * @param enableReadOnlyEditFields - Whether to apply read-only/locked styles
 * @returns Object with CSS selector keys and their corresponding disabled styles, or empty object if not enabled
 */
export const createDealLockStyles = (enableReadOnlyEditFields?: boolean): Record<string, any> => {
    if (!enableReadOnlyEditFields) return {};

    return {
        [DEAL_LOCK_SELECTORS.VIN_BUTTONS]: COMMON_DISABLED_STYLES,
        [DEAL_LOCK_SELECTORS.TEXT_CUSTOMER_BUTTON]: COMMON_DISABLED_STYLES
    };
};
